Ext.ns('mx.comp');

mx.comp.CheckboxedField = Ext.extend(mx.comp.FieldGroup, {
    fieldConfig: {},
    checkboxLabel: 'Empty',
    checkboxWidth: 80,
    checkboxName: null,
    fieldForm: Ext.form.TextField,

    initComponent: function() {
        mx.comp.CheckboxedField.superclass.initComponent.call(this);

        this.columns = [1, this.checkboxWidth];

        this.defaults = {
            anchor: '-5',
        };

        this.items = [
            (this.field = new this.fieldForm(this.fieldConfig)),
            (this.checkbox = new Ext.form.Checkbox({
                boxLabel: this.checkboxLabel,
                name: this.checkboxName || 'none',
                handler: function(cb, checked) {
                    this.field.setDisabled(checked);
                },
                scope: this,
            })),
        ];
    },

    setValue: function() {
        this.field.setValue.apply(this, arguments);
    },

    getValue: function() {
        return this.field.setValue.apply(this, arguments);
    },
});
